import ApiManager from '../../api/crud-manager';
import Incrementer from '../incrementer';

class OrderHistoryDropdown {
  constructor() {
    this.config = {
      module: document.querySelector('[data-module="OrderHistoryDropdown"]'),
      loaded: false
    };
    this.apiManager = new ApiManager();
  }

  init() {
    const { module } = this.config;

    if (!module) {
      return;
    }

    const template = 'OrderOverviewDropdown';
    const items = module.dataset.orderItems || 10;

    if (template != null) {
      module.classList.add('is-loading');

      const url = `/api/v2/catalog/customer/order/history?page=1&items=${items}&template=${template}&AddDeliveryDate=1`;

      this.apiManager.get(url, 'text/html').then(data => {
        this.renderOrders(data, module);
      });
    }
  }

  renderOrders(data, initiator) {
    const { module } = this.config;
    const { loaded } = this.config;

    module.classList.remove('is-loading');

    if (data.length > 0) {
      if (!loaded) {
        this.config.loaded = true;
      }

      if (!loaded) {
        initiator.innerHTML = data;
      } else {
        initiator.innerHTML += data;
      }

      const loadMore = module.querySelector('[data-module="OrderHistoryLoadMore"]');

      if (loadMore) {
        const { pageNumber, totalPages } = loadMore.dataset;

        if (parseInt(pageNumber, 10) === 1) {
          this.initLoadMoreButton(module);
        }
        if (parseInt(pageNumber, 10) === parseInt(totalPages, 10)) {
          loadMore.remove();
        }

        loadMore.dataset.pageNumber = parseInt(pageNumber, 10) + 1;
      }

      this.addEventListeners(module);

      if (window.location.hash) {
        const hash = window.location.hash.substring(1);
        const id = hash.replace(/^\D+/g, '');
        $(`#${hash}`).collapse('show');
        this.findOrderById(id);
      }
    } else {
      const loadMore = module.querySelector('[data-module="OrderHistoryLoadMore"]');
      if (loadMore) {
        loadMore.remove();
      }
    }
  }

  findOrderById(id) {
    const element = document.querySelector(`#collapse-${id}`);

    setTimeout(() => {
      const pos = $(`#${id}`).offset().top - $('.c-header').height() - 100;
      $('html').animate({ scrollTop: pos });
    }, 500);

    if (element && !element.classList.contains('has-data')) {
      const url = `/api/v2/catalog/customer/order/history?template=OrderOverviewDropdownDetail&ordernumber=${id}&AddDeliveryDate=1`;
      element.classList.add('is-loading');
      this.apiManager.get(url, 'text/html').then(data => {
        OrderHistoryDropdown.renderOrderDetails(data, element);
      });
    }
  }

  static renderOrderDetails(data, initiator) {
    initiator.innerHTML = data;
    initiator.classList.remove('is-loading');
    initiator.classList.add('has-data');

    // eslint-disable-next-line no-undef
    cart.addEventListener(); // trigger ancient cart module
    new Incrementer().init();
  }

  initLoadMoreButton(module) {
    const loadMore = module.querySelector('[data-module="OrderHistoryLoadMore"]');

    if (loadMore) {
      loadMore.addEventListener('click', e => {
        e.preventDefault();
        const { pageNumber } = loadMore.dataset;
        loadMore.disabled = true;
        this.loadMoreOrders(module, pageNumber, loadMore);
      });
    }
  }

  loadMoreOrders(module, pageNumber, loadMore) {
    module.classList.add('is-loading');
    const template = 'OrderOverviewDropdownLoadMore';
    const items = module.dataset.orderItems || 10;

    const url = `/api/v2/catalog/customer/order/history?items=${items}&template=${template}&page=${pageNumber}&AddDeliveryDate=1`;

    const ordersHolder = module.querySelector('[data-child-module="OrdersHolder"]');
    this.apiManager.get(url, 'text/html').then(data => {
      this.renderOrders(data, ordersHolder);
      loadMore.disabled = false;
    });
  }

  addEventListeners(module) {
    const orderHistoryDetail = module.querySelectorAll('[data-child-module="OrderHistoryDetail"]');

    if (orderHistoryDetail.length > 0) {
      for (let i = 0; i < orderHistoryDetail.length; i += 1) {
        const link = orderHistoryDetail[i];
        link.addEventListener(
          'click',
          e => {
            e.preventDefault();
            const id = link.dataset.orderNumber;
            if (id != null) {
              this.findOrderById(id);
            }
          },
          true
        );
      }
    }
  }
}
export default OrderHistoryDropdown;
